import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';

const BUDGET_GROUP_PREFIX = 'budget__';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private authenticationService: AuthenticationService) {}
  checkAccess(permKeys: string[]) {
    let canAccess = false;
    for (let i = 0; i < permKeys.length; i++) {
      let permKey = permKeys[i];

      if (permKey.startsWith(BUDGET_GROUP_PREFIX)) {
        permKey = permKey.replace(BUDGET_GROUP_PREFIX, '');
        canAccess = this.checkBudgetAccess(permKey);
        if (canAccess) {
          break;
        }
      }

      canAccess = this.checkRole(permKey);
      if (canAccess) {
        break;
      }
    }

    return canAccess;
  }

  checkBudgetAccess(key: string): boolean {
    const userInfo = this.authenticationService
      .currentUserInfo as any;
    return userInfo?.[key] === true;
  }

  checkRole(role: string): boolean {
    return role === this.authenticationService.role;
  }
}
